// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'

import App from './App'
import router from './router'

import store from './store'
import * as types from './store/mutation-types'

import * as firebase from 'firebase'

import AlertComponent from './components/shared/AlertComponent.vue'

// import 'jquery-dropdown/jquery-dropdown.css'

// Bootstrap
require('./bootstrap')

window.SETTINGS = {
  // How many different dispatched actions determine loading progress
  // This is likely determined by how many dispatched actions you have below
  // in the created() method
  LOADING_SEGMENTS: 2,
  API_BASE_PATH: '/wp-json/wp/v2/'
}

Vue.use(Vuetify)

Vue.component('app-alert', AlertComponent)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  },
  created () {
    this.$store.commit(types.RESET_LOADING_PROGRESS)
    firebase.initializeApp({
      apiKey: 'AIzaSyDiOGlwWkyoRchjeZbythuuONicCK7aqH4',
      authDomain: 'sbp-website-2018.firebaseapp.com',
      databaseURL: 'https://sbp-website-2018.firebaseio.com',
      projectId: 'sbp-website-2018',
      storageBucket: 'sbp-website-2018.appspot.com'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js